import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { useAuth } from '../../contexts/AuthContext';
import { db } from '../../services/firebase';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';

const MyReviews = () => {
  const { currentUser } = useAuth();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (currentUser) {
      loadUserReviews();
    }
  }, [currentUser]);

  const loadUserReviews = async () => {
    if (!currentUser) return;

    try {
      setLoading(true);
      const reviewsRef = collection(db, 'reviews');
      const q = query(
        reviewsRef,
        where('userId', '==', currentUser.uid),
        orderBy('createdAt', 'desc')
      );

      const querySnapshot = await getDocs(q);
      const reviewsData = [];
      querySnapshot.forEach((doc) => {
        reviewsData.push({
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt?.toDate ? doc.data().createdAt.toDate() : new Date(doc.data().createdAt)
        });
      });

      setReviews(reviewsData);
    } catch (error) {
      console.error('Error loading reviews:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          style={{
            color: i <= rating ? '#FFD700' : '#E0E0E0',
            fontSize: '1.25rem'
          }}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  const formatDate = (date) => {
    if (!date) return 'Fecha desconocida';
    return new Intl.DateTimeFormat('es', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  };

  return (
    <Layout>
      <div style={{
        padding: windowWidth <= 640 ? '1rem' : '2rem',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: windowWidth <= 640 ? 'flex-start' : 'center',
          flexDirection: windowWidth <= 640 ? 'column' : 'row',
          gap: windowWidth <= 640 ? '1rem' : '0',
          marginBottom: '2rem'
        }}>
          <div>
            <h1 style={{
              fontSize: windowWidth <= 640 ? '1.5rem' : '2rem',
              fontWeight: '700',
              color: '#2e7d32',
              margin: '0 0 0.5rem 0'
            }}>
              Mis Reseñas
            </h1>
            <p style={{
              fontSize: '1rem',
              color: '#666',
              margin: 0
            }}>
              Aquí puedes ver todas las reseñas que has dejado
            </p>
          </div>
          <Link 
            to="/"
            style={{
              textDecoration: 'none',
              color: 'inherit',
              width: windowWidth <= 640 ? '100%' : 'auto'
            }}
          >
            <button 
              className="btn btn-secondary"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.75rem 1.25rem',
                width: windowWidth <= 640 ? '100%' : 'auto',
                justifyContent: windowWidth <= 640 ? 'center' : 'flex-start'
              }}
            >
              <span>←</span>
              Volver al Dashboard
            </button>
          </Link>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}>
            <div className="modern-loading-spinner"></div>
            <p style={{ marginTop: '1rem', color: '#666' }}>Cargando tus reseñas...</p>
          </div>
        ) : reviews.length > 0 ? (
          <div className="modern-grid" style={{
            display: 'grid',
            gridTemplateColumns: windowWidth <= 640 ? '1fr' : windowWidth <= 1024 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
            gap: '1.5rem'
          }}>
            {reviews.map((review) => (
              <div 
                key={review.id} 
                className="modern-card"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%'
                }}
              >
                <div style={{
                  padding: '1.5rem',
                  borderBottom: '1px solid #eee',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}>
                  <div>
                    <h3 style={{
                      fontSize: '1.25rem',
                      fontWeight: '600',
                      margin: '0 0 0.5rem 0'
                    }}>
                      {review.service}
                    </h3>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.25rem'
                    }}>
                      {renderStars(review.rating)}
                    </div>
                  </div>
                  <div style={{
                    fontSize: '0.875rem',
                    color: '#666'
                  }}>
                    {formatDate(review.createdAt)}
                  </div>
                </div>
                
                <div style={{
                  padding: '1.5rem',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  {review.reviewText ? (
                    <p style={{
                      margin: 0,
                      color: '#333',
                      lineHeight: '1.6',
                      fontSize: '1rem'
                    }}>
                      "{review.reviewText}"
                    </p>
                  ) : (
                    <p style={{ 
                      margin: 0, 
                      color: '#888',
                      fontStyle: 'italic'
                    }}>
                      No se proporcionó texto para esta reseña.
                    </p>
                  )}
                </div>
                
                <div style={{
                  padding: '1rem 1.5rem',
                  borderTop: '1px solid #eee',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '0.875rem',
                  color: '#666',
                  backgroundColor: '#f9f9f9'
                }}>
                  <div>
                    Cita #{review.appointmentId?.substring(0, 6)}...
                  </div>
                  <Link 
                    to={`/submit-review?appointmentId=${review.appointmentId}&service=${encodeURIComponent(review.service)}&edit=true`}
                    style={{ 
                      color: '#2e7d32',
                      textDecoration: 'none',
                      fontWeight: '500'
                    }}
                  >
                    Editar
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="modern-empty-state">
            <div className="modern-empty-icon">⭐</div>
            <h4 className="modern-empty-title">No has dejado ninguna reseña todavía</h4>
            <p className="modern-empty-description">
              Cuando completes servicios, podrás dejar tus comentarios y calificaciones aquí
            </p>
            <Link to="/appointments">
              <button
                className="btn btn-primary"
                style={{
                  background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                  border: 'none',
                  color: 'white',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 8px rgba(34, 197, 94, 0.2)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(34, 197, 94, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 8px rgba(34, 197, 94, 0.2)';
                }}
              >
                Ver Mis Citas
              </button>
            </Link>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default MyReviews;
